var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PAGE_OUTSTYLE organization"},[_c('el-card',{staticClass:"left_card"},[_c('Organize',{ref:"organize",on:{"chooseOrg":_vm.getChooseOrganizeData}})],1),_c('el-card',{staticClass:"right_card"},[_c('Member',{attrs:{"orgdata":_vm.orgdata}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }